import { render, staticRenderFns } from "./feature-type.vue?vue&type=template&id=1881cfcf&scoped=true&"
import script from "./feature-type.vue?vue&type=script&lang=js&"
export * from "./feature-type.vue?vue&type=script&lang=js&"
import style0 from "./feature-type.vue?vue&type=style&index=0&id=1881cfcf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1881cfcf",
  null
  
)

export default component.exports